import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {CDFAsset, CDFItem, CDFItemCandidate} from "../cdf/cdf.gql-model";
import {FormControl, FormGroup} from "@angular/forms";

export type AssignMode = null | "self" | "allEmpty" | "allSameProductNumber" | "allSameDeviceKey";

export interface DealKeySelectionData {
  assignable: CDFItem;
  allItems: CDFAsset[];
}

@Component({
  templateUrl: "./deal-key-selection-dialog.template.pug",
  styles: [
    ".selectionTable > tbody > tr > td { border-top: none; padding: 0.5em 1.75em 0.5em 0.25em; }",
    ".selectionTable > tr > th { padding: 0.5em 1.75em 0.5em 0.25em; }",
  ],
})
export class DealKeySelectionDialogComponent
  extends DialogComponent<DealKeySelectionData, boolean>
  implements DealKeySelectionData {
  assignable: CDFItem;
  allItems: CDFAsset[];
  result: boolean = false;
  allowUpdateByDeviceKey: boolean = false;

  form: FormGroup = new FormGroup({
    mode: new FormControl("self"),
  });

  static show(dialogService: DialogService, assignable: CDFItem, allItems: CDFAsset[]): Promise<boolean> {
    return dialogService.showDialog(DealKeySelectionDialogComponent, {assignable, allItems});
  }

  ready() {
    this.allowUpdateByDeviceKey = !!this.assignable.deviceKey;
  }

  applyCandidate(assignable: CDFItem, candidate: CDFItemCandidate) {
    if (candidate) {
      assignable.associateDevice(candidate);
    } else {
      assignable.clearDevice();
    }
  }

  applyCandidates(candidate: CDFItemCandidate, condition: (item: CDFItem) => boolean) {
    const matchCandidate = it => it.id === candidate.id;

    for (const item of this.allItems) {
      if (condition(item)) {
        const match = item.candidates.find(matchCandidate);
        if (match) this.applyCandidate(item, match);
      }

      for (const accessory of item.accessories) {
        if (condition(accessory)) {
          const match = accessory.candidates.find(matchCandidate);
          if (match) this.applyCandidate(accessory, match);
        }
      }
    }
  }

  select(candidate: CDFItemCandidate) {
    const mode: AssignMode = this.form.controls["mode"].value || null;
    const changed = this.assignable.isDifferent(candidate) || (mode && /^all/.test(mode));

    const currentDeviceKey = this.assignable.deviceKey;
    const currentProductNumber = this.assignable.productNumber;

    this.applyCandidate(this.assignable, candidate);

    if (mode === "allEmpty") {
      this.applyCandidates(candidate, item => !item.deviceKey);
    }

    if (mode === "allSameDeviceKey") {
      this.applyCandidates(candidate, item => item.deviceKey === currentDeviceKey);
    }

    if (mode === "allSameProductNumber") {
      this.applyCandidates(candidate, item => item.productNumber === currentProductNumber);
    }

    this.result = changed;
    this.close();
  }

  close() {
    super.close();
  }

  constructor(dialogService: DialogService) {
    super(dialogService);
  }
}
